import React, { useState } from "react";
import EnquiryResult from "./EnquiryResult";
import EnquiryForm from "./EnquiryForm";
import axios from "axios";

const Enquiry = () => {
  const BaiscUrl = `${process.env.REACT_APP_BACKEND}?search=`;
  const [FilterResult, setFilterResult] = useState(null);
  const [voterData, setVoterData] = useState({});

  const submitHandler = async (e) => {
    const numberWord = e.split(" ").length;
    if (numberWord >= 0) {
      try {
        const response = await axios.get(`${BaiscUrl}${e}`);
        const results = response?.data.data[0];
        setVoterData({
          name: results?.name ? results?.name : null,

          aldaayira: results?.aldaayira ? results.aldaayira.trim() : null,
          committee: results?.number_of_aldaayira
            ? results?.number_of_aldaayira
            : null,
          number_of_registration: results?.number_of_aldaayira
            ? results?.number_of_aldaayira
            : null,
          area: results?.area ? results?.area.trim() : null,
          status: results?.status ? results?.status : null,
          school: results?.school ? results?.school : null,
          Y: results?.Y ? results?.Y : null,
          X: results?.X ? results?.X : null,
        });
      } catch (error) {}
    } else {
      alert("الرجاء ادخال الاسم ثلاثي");
    }
  };

  const filterHandler = async (filterValue) => {
    if (filterValue !== null && filterValue !== "") {
      const numberWord = filterValue.split(" ").length;
      if (numberWord > 0) {
        try {
          const response = await axios.get(`${BaiscUrl}${filterValue}`);
          setFilterResult(response.data.data.map((item) => item.name));
        } catch (error) {
          console.log(error);
        }
      } else {
        setFilterResult(null);
      }
    } else {
      setFilterResult(null);
    }
  };

  return (
    <React.Fragment>
      <div className="">
        <EnquiryForm
          submitHandler={submitHandler}
          filterResult={FilterResult}
          filterHandler={filterHandler}
        />
        <EnquiryResult result={voterData} />
      </div>
    </React.Fragment>
  );
};

export default Enquiry;
